<template>
  <div>
    <div
      class="spinner"
      id="spinner"
      v-show="spinnerOn"
    ></div>
    <div class="banner page-head flex-box" style="min-height:100px">
      <div class="w-100">
        <div class="container">
          <div class="banner-caption text-center">
            <h2 class="features-header-text ml-0 text-center
            ">Blog Post</h2>
            <h5 style="color: #676767;">Our Work is the bridge to various insightful digital experiences.</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="blog-wrp">
      <div class="container">
        <div class="blog-list">
          <div class="row">
            <div
              class="col-sm-6 col-md-6 col-lg-4"
              v-for="(blog, index) in blogs_list"
              :key="index"
              style="cursor:pointer"
              @click="redirect_to_blog(index)"
            >
              <div class="blog-blk">
                <div class="blog-img">
                  <img class="js-lazy-image" :data-src="blog.blog_img" alt style="border-top-left-radius: 5%;border-top-right-radius: 5%;">
                </div>
                 <div class="blog-det">
                  <ul class="det">
                    <li>{{blog.by}}</li>
                    <li>{{blog.blog_date}}</li>
                    <!-- <li>{{blog.comments_count}} Comments</li> -->
                  </ul>
                </div>
                <div class="blog-desc">
                  <h3>{{blog.blog_title}}</h3>
                  <p
                    :id="'description'+index"
                  >
                  {{blog.blog_short_description}}
                  </p>
                  <a href="#" class="read-more" style="color:#283677"> - Read More</a>
                </div>
               
              </div>
            </div>
          </div>
          <!-- <div class="blog-pagin">
            <nav aria-label="Page navigation example">
              <ul class="pagination text-center">
                <li class="page-item first">
                  <a class="page-link" href="#">
                    <img class="mr-2" src="/static/images/left-ar.png" alt>Older Page
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">1</a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">2</a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">3</a>
                </li>
                <li class="page-item last">
                  <a class="page-link" href="#">
                    Next Page
                    <img class="ml-2" src="/static/images/right-ar.png" alt>
                  </a>
                </li>
              </ul>
            </nav>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import AOS from "aos";
import axios from "axios";
export default {
  data() {
    return {
      blogs_list: [],
      observer: null,
      spinnerOn: false,
    };
  },
  created() {
    this.spinnerOn = true;
    this.$CensePortalHttp
      .post('home/blog-list', {
        getAll: "True"
      })
      .then(response => {
        this.spinnerOn = false;
        for (var i in response.data[0]) {
          // console.log(i);
          // console.log(response.data[3][i]);
          var short = document.createElement("div");
          short.innerHTML = response.data[3][i];
          // console.log(short)
          this.blogs_list.push({
            by: "Amit",
            blog_title: response.data[0][i],
            blog_type: response.data[1][i],
            blog_img: response.data[2][i],
            content: response.data[3][i],
            blog_short_description: short.innerText,
            blog_date: response.data[4][i]
          });
        }
        setTimeout(() => {
          this.setIntersectionObserver();
        }, 0);
      });
  },
  methods: {
    redirect_to_blog(index) {
      // this.$session.set("Blog to be displayed", this.blogs_list[index]);
      this.$router.push({
        name: 'BlogDetails', 
        params: {
          title: this.blogs_list[index]['blog_title']
        }
      })
    },
    setIntersectionObserver() {
      // Get all of the images that are marked up to lazy load
      const images = document.querySelectorAll('.js-lazy-image');
      const config = {
        // If the image gets within 50px in the Y axis, start the download.
        rootMargin: '50px 0px',
        threshold: 0.01
      };
      // The observer for the images on the page
      // If we don't have support for intersection observer, load the images immediately
      if (!('IntersectionObserver' in window)) {
        Array.from(images).forEach(image => preloadImage(image));
      } else {
        // It is supported, load the images
        this.observer = new IntersectionObserver(this.onImageIntersection, config);
        images.forEach(image => {
            this.observer.observe(image);
        });
      }
    },
    onImageIntersection(entries) {
      // Loop through the entries
      entries.forEach(entry => {
        // Are we in viewport?
        if (entry.intersectionRatio > 0) {
            // Stop watching and load the image
            this.observer.unobserve(entry.target);
            entry.target.src = entry.target.dataset.src.toString();
        }
      });
    },
  }
};
AOS.init({
  easing: "ease-out-back",
  duration: 1000
});
// jQuery(".tag-line").each(function() {
//   var Width = jQuery(this);
//   var PW = Width.parent().width();
//   Width.css("max-width", PW + "px");
// });
// jQuery(function() {
//   jQuery(".fix-img").each(function() {
//     var img = jQuery(this);
//     var image_heightA = img.height();
//     var image_widthA = img.width();
//     var parent_image_widthA = img.parent().width();
//     var parent_image_heightA = img.parent().height();
//     // if(width <= height)

//     if (
//       image_heightA > parent_image_heightA &&
//       image_widthA > parent_image_widthA
//     ) {
//       img.css("width", parent_image_widthA + "px");
//       var tem_image_heightA = img.height();

//       if (tem_image_heightA > parent_image_heightA) {
//         img.css("width", "100%");
//       } else {
//         img.css("width", "auto");
//         img.css("height", "100%");
//       }
//     } else {
//       img.css("width", parent_image_widthA + "px");
//       var tem_image_heightA = img.height();

//       if (tem_image_heightA > parent_image_heightA) {
//         img.css("width", "100%");
//       } else {
//         img.css("width", "auto");
//         img.css("height", "100%");
//       }
//     }
//   });
// });
</script>

<style scoped>
.blog-desc p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
